export default "__VITE_ASSET__C8rgYJ8s__"